import IconBlock from '@component/common/block/icon-block';
import * as color from '@constant/color';
import React from 'react';
import TextBlock from '@component/common/block/text-block';
import styled from 'styled-components';
import { v4 as uuid4 } from 'uuid';

interface IProps {
  maxDifficulty: number;
  currentDifficulty: number;
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  // width: fit-content;
`;

const ICON_DESIGN = {
  icon: { size: 'small', color: color.GRAY_3, kind: 'outlined' },
  box: { width: '16px' },
} as const;

const Difficulty: React.FC<IProps> = ({ currentDifficulty, maxDifficulty }) => {
  return (
    <Wrapper>
      <TextBlock
        text={'난이도'}
        design={{ text: { size: 'small', color: color.GRAY_1, bold: true }, box: { margin: '0 5px 0 0' } }}
      />
      {Array.from({ length: maxDifficulty }, (_, index) => {
        const checked = index < currentDifficulty;
        return (
          <IconBlock
            key={uuid4()}
            icon='star'
            design={{
              box: ICON_DESIGN.box,
              icon: {
                ...ICON_DESIGN.icon,
                kind: checked ? 'outlined' : 'filled',
                checkedColor: color.YELLOW_1,
                checked: checked,
              },
            }}
          />
        );
      })}
    </Wrapper>
  );
};

export default Difficulty;
